import { apiGetCountries } from '@/api';
import * as types from '@/store/mutation-types';

// initial state
const state = {
  all: []
};

// mutations
const mutations = {
  [types.RECEIVED_COUNTRIES] (state, data) {
    data.data.forEach(function (element) {
      element.enabled = false;
    });

    state.all = data.data;
  },

  [types.UPDATE_COUNTRIES_ENABLED] (state, data) {
    state.all.forEach(el => el.enabled = false);
    state.all.find((el) => {
      if (el.id === data.id) {
        el.enabled = data.enabled;
      }
    });
  },
};

const actions = {
  getCountries: ({ commit }, args = {}) => {
    return apiGetCountries(args).then(({ data }) => {
      // success
      commit(types.RECEIVED_COUNTRIES, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },

  toggleCountryEnabledFilter: ({ commit, dispatch, state }, data) => {
    commit(types.UPDATE_COUNTRIES_ENABLED, data);
  },
};

const getters = {
  countries (state) {
    return state.all;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/countries.js